var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.7333C5.03671 9.36385 6.36904 10.6665 8 10.6665C9.63096 10.6665 10.9633 9.36385 11 7.7333V7.70829C11.0009 6.8549 10.6343 6.04245 9.99392 5.47839C9.81488 5.32798 9.56477 5.29527 9.35308 5.39459C9.14139 5.49391 9.00668 5.70716 9.00791 5.94099L9.00817 7.58328C9.00817 7.66612 8.94101 7.73328 8.85817 7.73328H7.14182C7.05898 7.73328 6.99182 7.66612 6.99182 7.58328L6.99207 5.94099C6.99331 5.70716 6.8586 5.49391 6.64691 5.39459C6.43522 5.29527 6.18511 5.32798 6.00607 5.47839C5.3657 6.04245 4.99914 6.8549 5 7.70829",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 13.8512V10.3616",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 13.8512V10.3616",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/wrench.c2f9f30539eb20445171a432bcafe7e9.svg";
export { ForwardRef as ReactComponent };